/*
useInfoModalContext.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { useContext } from 'react';
import { InfoModalContext } from './InfoModalContext';


export const useInfoModalContext = () => {
  const context = useContext(InfoModalContext);
  if (!context) {
    throw new Error("useInfoModalContext must be used within a InfoModalContextProvider");
  }
  return context;
};
